// extracted by mini-css-extract-plugin
export default {"phone":"ProfSer_phone__85HlU"};